import { Component, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';

import {
  VipDiscountsBuyingActions,
  VipDiscountsBuyingSelectors,
} from '../../store/vip-discounts.slice';

@Component({
  selector: 'app-vip-discounts-received',
  templateUrl: './vip-discounts-received.component.html',
  styleUrls: ['./vip-discounts-received.component.scss'],
})
export class VipDiscountsReceivedComponent implements OnInit {
  constructor(private store: Store) {}

  discountsReceived$ = this.store.select(
    VipDiscountsBuyingSelectors.selectDiscountsReceived
  );
  discountsReceivedLoading$ = this.store.select(
    VipDiscountsBuyingSelectors.selectDiscountsReceivedLoading
  );
  ngOnInit(): void {
    this.store.dispatch(
      VipDiscountsBuyingActions.loadDiscountsReceived.trigger()
    );
  }
}
